/* eslint-disable import/no-relative-packages */
/** @type {import('next-sitemap').IConfig} */
module.exports = {
  siteUrl: 'https://blockquiry.com',
  generateRobotsTxt: true,
  blockQuiry_connect_secret:
    "GB8#p*ko7Mp]oJ8iTO2ItDcvtw{i5;k5vks/GTy;f;#p}3*.q!A-G][.-|='HghXf;uIU'VU-r1VJRtiJcVW'FXT9wuLX'+T8wkcm?zL).}1d*a",
  // baseUrlApp: 'http://13.49.44.48:3000/',
  baseUrlApp: 'http://localhost:3000/',
  // ...other options
};
